function setupCustomDeliveryWidget() {
  document.body.querySelectorAll(".zapiet-search").forEach(function (form) {
    form.addEventListener("submit", async function (e) {
      e.preventDefault();

      const input = form.querySelector('input[type="text"], input[type="email"]');
      const rawPostcode = input?.value?.trim() || "";
      const postcode = rawPostcode.replace(/[^0-9]/g, "");
      if (!postcode) return;

      const modal = document.getElementById("custom-delivery-modal");
      const ghostModal = document.getElementById("custom-delivery-ghost-modal");
      const modalTitle = document.getElementById("custom-delivery-modal__title");
      const modalBody = document.getElementById("custom-delivery-modal__body");
      const modalPrimary = document.getElementById("custom-delivery-modal__primary");
      const modalClose = document.getElementById("custom-delivery-modal__close");

      const showGhostModal = () => {
        ghostModal.style.display = "flex";
        document.body.style.overflow = "hidden";
      };

      const hideGhostModal = () => {
        ghostModal.style.display = "none";
      };

      const showModal = () => {
        hideGhostModal();
        modal.style.display = "flex";
        document.body.style.overflow = "hidden";
      };

      const hideModal = () => {
        modal.style.display = "none";
        document.body.style.overflow = "";
      };

      const showSuccessModal = () => {
        modalTitle.textContent = "Great, we deliver to your area!";
        modalBody.innerHTML = "<p>To start shopping just click the button below</p>";
        modalPrimary.textContent = "Continue Shopping";
        modalPrimary.onclick = hideModal;
        showModal();
      };

      const showOutOfAreaModal = (pc) => {
        modalTitle.textContent = "Sorry, we do not deliver to your area";
        modalBody.innerHTML = `
          <div class="outofarea">
            <p class="outofarea__text">Enter your email below to be notified when we deliver to your area</p>
            <input class="outofarea__input custom-input" type="email" placeholder="Enter email" />
            <div class="outofarea__feedback" style="display:none">Thanks! You're on the list.</div>
            <div class="outofarea__error" style="display:none">Please enter a valid email.</div>
          </div>
        `;
        modalPrimary.textContent = "Get Notified";
        
        const emailInput = modalBody.querySelector(".outofarea__input");
        const feedback = modalBody.querySelector(".outofarea__feedback");
        const error = modalBody.querySelector(".outofarea__error");

        const isValidEmail = (email) => /.+@.+\..+/.test(email);

        const subscribeOutOfArea = async (email) => {
          let clientSuccess = false;
          let serverSuccess = false;

          // Optional: Klaviyo tracking via client (no secret key required)
          if (window._learnq) {
            try {
              window._learnq.push(["identify", {
                $email: email,
                $consent: ["email"],
                postcode: pc,
                out_of_area: true
              }]);
              window._learnq.push(["track", "Out Of Area", { postcode: pc }]);
              clientSuccess = true;
            } catch (e) {
              console.warn("Klaviyo identify/track failed", e);
            }
          }

          // Subscribe via server to Klaviyo (requires private API key). Send to our app endpoint.
          try {
            const res = await fetch("https://billybubbles.com/apps/order-api", {
              method: "POST",
              headers: { "Content-Type": "application/json" },
              body: JSON.stringify({
                type: "klaviyo_ooa_subscribe",
                listId: "Wk5Ufc",
                email,
                consent: ["email"],
                properties: { postcode: pc, out_of_area: true, source: "Header Delivery Checker", ooa_tag: "Out Of Area" }
              }),
            });

            if (res.ok) {
              const data = await res.json().catch(() => ({}));
              serverSuccess = true;
            } else {
              console.warn("Server subscription failed with status:", res.status);
            }
          } catch (e) {
            console.warn("Server subscription failed", e);
          }

          return serverSuccess || clientSuccess;
        };

        // Enter key submits
        emailInput?.addEventListener("keydown", async (ev) => {
          if (ev.key === "Enter") {
            ev.preventDefault();
            modalPrimary.click();
          }
        });

        modalPrimary.onclick = async () => {
          const email = emailInput?.value?.trim();
          if (!email || !isValidEmail(email)) {
            if (error) error.style.display = "block";
            if (feedback) feedback.style.display = "none";
            return;
          }
          if (error) error.style.display = "none";
          if (feedback) feedback.style.display = "none";

          // Provide immediate feedback / disable to avoid double submits
          modalPrimary.classList.add("is-loading");
          modalPrimary.disabled = true;

          const success = await subscribeOutOfArea(email);

          modalPrimary.classList.remove("is-loading");
          modalPrimary.disabled = false;

          if (success) {
            if (feedback) feedback.style.display = "block";
            // Update primary action to acknowledge subscription
            modalPrimary.textContent = "Thanks — we'll notify you";
            modalPrimary.disabled = true;
            
            // Close popup after 3 seconds
            setTimeout(() => {
              hideModal();
              modalPrimary.disabled = false;
            }, 3000);
          } else {
            if (error) {
              error.textContent = "Sorry, there was an error. Please try again.";
              error.style.display = "block";
            }
          }
        };

        showModal();
      };

      // Close modal handlers
      modal.querySelector(".custom-delivery-modal__backdrop").onclick = hideModal;
      ghostModal.querySelector(".custom-delivery-modal__backdrop").onclick = () => {
        hideGhostModal();
        document.body.style.overflow = "";
      };

      // Show ghost modal immediately
      showGhostModal();

      try {
        // Check postcode via custom endpoint
        const res = await fetch("https://billybubbles.com/apps/order-api", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ type: "postcode", postcode: Number(postcode) }),
        });
        const data = await res.json().catch(() => ({}));
        const exists = !!data?.exists;

        if (exists) {
          // Show success modal
          showSuccessModal();
        } else {
          // Show out of area modal with email capture
          showOutOfAreaModal(postcode);
        }
      } catch (err) {
        console.warn("Postcode check failed", err);
        modalTitle.textContent = "Error";
        modalBody.innerHTML = "<p>Sorry, there was an error checking your postcode. Please try again.</p>";
        modalPrimary.textContent = "Close";
        modalPrimary.onclick = hideModal;
        showModal();
      }
    });
  });
}

document.addEventListener("DOMContentLoaded", () => {
  setupCustomDeliveryWidget();

  // Header scroll animation
  const header = document.querySelector("#MainHeader");
  const spacer = document.querySelector("#MainHeaderSpacer");
  const stickyWrapper = document.querySelector(".header-sticky__wrapper");
  
  let hasScrolledPast = false;
  let isCartForceActivated = false;

  const getHeaderHeight = () => header.offsetHeight;
  const getHeaderBottom = () => stickyWrapper.getBoundingClientRect().bottom;
  const placeholder = document.createElement('div');
  const deliveryMobile = document.querySelector('.header-delivery__mobile');

  // Sticky wrapper scroll handler
  if (stickyWrapper) {
    // Create placeholder element to prevent page jump
    placeholder.className = 'header-sticky__placeholder';
    stickyWrapper.parentNode.insertBefore(placeholder, stickyWrapper);
    placeholder.style.height = `${stickyWrapper.offsetHeight}px`;

    //stickyWrapper.classList.add('is-fixed');
    if (!deliveryMobile || !window.matchMedia('(max-width: 768px)').matches) {
      stickyWrapper.classList.add('is-fixed');
      placeholder.style.display = 'block';
    }
  }

  function activateHeader() {
    if (!hasScrolledPast && !isCartForceActivated) {
      spacer.style.height = `${getHeaderHeight()}px`;
      header.classList.add("page-scrolled");

      requestAnimationFrame(() => {
        setTimeout(() => {
          header.classList.add("header-animation");
        }, 0);
      });

      isCartForceActivated = true;
    }
  }

  function activateHeaderOnMobile() {
    // Only activate header animation on mobile screens (768px and below)
    if (window.matchMedia('(max-width: 768px)').matches) {
      activateHeader();
    }
  }

  function deactivateHeaderIfCartForced() {
    if (isCartForceActivated && !hasScrolledPast) {
      spacer.style.height = "0";
      header.classList.remove("header-animation");
      header.classList.remove("page-scrolled");
      isCartForceActivated = false;
    }
  }


  window.addEventListener("scroll", () => {
    const currentScroll = window.scrollY;

    if (!deliveryMobile || !window.matchMedia('(max-width: 768px)').matches) return;

    if (deliveryMobile && currentScroll < deliveryMobile.offsetHeight) {
      stickyWrapper.classList.remove('is-fixed');
      placeholder.style.display = 'none';
      return;
    } else if (deliveryMobile) {
      stickyWrapper.classList.add('is-fixed');
      placeholder.style.display = 'block';
    }
    return;

    if (currentScroll > 692 && !hasScrolledPast) {
      spacer.style.height = `${getHeaderHeight()}px`;
      // Step 1: Add fixed positioning and off-screen transform
      header.classList.add("page-scrolled");

      // Step 2: Delay just enough for transform to apply before animating
      requestAnimationFrame(() => {
        setTimeout(() => {
          header.classList.add("header-animation");
        }, 0);
      });

      hasScrolledPast = true;
      isCartForceActivated = false; // Clear cart force when naturally scrolled
    } else if (currentScroll <= 692 && hasScrolledPast) {
      spacer.style.height = "0";
      // Remove both to reset
      header.classList.remove("header-animation");
      header.classList.remove("page-scrolled");
      hasScrolledPast = false;
      isCartForceActivated = false;
    }
  });

  // Cart dropdown opening detection
  const observeCartDropdown = () => {
    const cartDropdown = document.getElementById("cart-dropdown");
    if (!cartDropdown) return;

    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.type === "attributes" && mutation.attributeName === "class") {
          const hasExpandedClass = cartDropdown.classList.contains("expanded");
          if (window.matchMedia('(max-width: 768px)').matches) {
            if (hasExpandedClass) {
              // Cart is opening - activate header only on mobile screens
              //activateHeaderOnMobile();
              cartDropdown.style.top = `${getHeaderBottom()}px`;
            } else {
              // Cart is closing - deactivate header only if it was cart-force-activated
              //deactivateHeaderIfCartForced();
              setTimeout(() => {
                cartDropdown.style.top = `inherit`;
              }, 300);
            }
          }
        }
      });
    });

    observer.observe(cartDropdown, { attributes: true });
  };

  // Initialize cart dropdown observer
  observeCartDropdown();
  
  // Re-initialize observer when cart is refreshed
  document.addEventListener("cart:refreshed", observeCartDropdown);
});

document.querySelectorAll(".header-delivery__close").forEach(function (btn) {
  btn.addEventListener("click", function () {
    const container = btn.closest(".header-delivery");
    const mobileContainer = btn.closest(".header-delivery__mobile");
    if (mobileContainer) mobileContainer.classList.add("hidden");
    if (container) container.classList.add("hidden");
  });
});
